import { useContext, useEffect, useState } from "react";
import { Card, Spinner } from "flowbite-react";
import CardList from "./cardList";
import CopyClipboard from "./copyClipboard";
import { GetFileExtension, Sort } from "../../utilities/utilityService";
import { DeleteModal } from "./deleteModal";
import { StorageContext } from "../../components/file-uploader/uploadSection";
import { usePaginate } from "../../hooks/usePaginate";
import {
  C_GENERAL,
  C_LEGAL_DOCUMENTS,
  C_TRADING_HOURS,
} from "../../constants/types";
import { ExcelModal } from "./excelModal";

export const HistoryCard = (props) => {
  const [data, setData] = useState();
  const { subCategory, isLoading } = useContext(StorageContext);

  const { showingItems, PaginateBtn } = usePaginate(data, subCategory);

  useEffect(() => {
    const categoryRoot = props.data[0]?.[props.formType];

    if (!categoryRoot) {
      setData(undefined);
      return;
    }

    if (props.formType === C_LEGAL_DOCUMENTS) {
      setData(categoryRoot[subCategory]);
    } else {
      setData(categoryRoot);
    }
  }, [props.data, props.formType, subCategory]);
  return (
    <div className="w-full mt-10">
      <Card className="flow-root">
        <ul className="st-1 divide-y divide-gray-200 dark:divide-gray-700">
          {data && !isLoading ? (
            props.formType === C_LEGAL_DOCUMENTS ||
            props.formType === C_TRADING_HOURS ||
            props.formType === C_GENERAL ? (
              Sort(data, props.filter)
                .slice(0, showingItems)
                .map((value, index) => {
                  return (
                    value.file && (
                      <li key={index} className="py-3 sm:py-4">
                        <CardList value={value} />
                        <div className="flex justify-between">
                          <div className="flex gap-2">
                            <CopyClipboard
                              data={value}
                              formType={props.formType}
                              subCategory={subCategory ? subCategory : ""}
                              customStyle="mt-4"
                            />
                            {(GetFileExtension(value.file_name) === "xls" ||
                              GetFileExtension(value.file_name) === "csv") && (
                              <ExcelModal
                                fileData={value}
                                subCategory={subCategory}
                              />
                            )}
                            {/* {GetFileExtension(value.file_name) === "pdf" && (
                              <div id="modalBtnSuccess" className="mt-4">
                                <Button>
                                  <a
                                    className="text-sm font-bold"
                                    rel="noreferrer"
                                    target="_blank"
                                    href={`/${PDF_VIEWER}?file=${value.file}`}
                                  >
                                    PDF
                                  </a>
                                </Button>
                              </div>
                            )} */}
                          </div>

                          <DeleteModal value={value} category={subCategory} />
                        </div>
                      </li>
                    )
                  );
                })
            ) : (
              <CardList value={data} />
            )
          ) : isLoading ? (
            <Spinner />
          ) : (
            "Nothing uploaded yet..."
          )}
        </ul>
      </Card>
      <div className="flex justify-center">
        {(props.formType === C_LEGAL_DOCUMENTS ||
          props.formType === C_GENERAL) && <PaginateBtn />}
      </div>
    </div>
  );
};
